import { render, staticRenderFns } from "./TimeoutAlert.vue?vue&type=template&id=2c6746d2&scoped=true&lang=pug&"
import script from "./TimeoutAlert.vue?vue&type=script&lang=js&"
export * from "./TimeoutAlert.vue?vue&type=script&lang=js&"
import style0 from "./TimeoutAlert.vue?vue&type=style&index=0&id=2c6746d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6746d2",
  null
  
)

export default component.exports